/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useEffect, useState } from 'react';
import styles from '../styles/Home.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import RoleRequestPage from '../../src/pages/roleRequestPage';
// import { isEmpty } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import MyRoleResources from '../components/forms/RoleRequest/MyRolesPage';
import RoleDescriptionPage from '../components/forms/RoleRequest/RoleDescriptionPage';

import { useAppSelector } from '../redux/hooks';
import { userRoleSelector } from '../redux/userRolesSlice';
import MyEngineModelStatus from '../components/Profile/MyEngineModelStatus';


const RoleRequestTabs = () => {

  const [value, setValue] = useState('1');
  const { roleResourceData } = useAppSelector(userRoleSelector);

  const navigate = useNavigate();

  const [widthscreen,setwidth] = useState(window.innerWidth);
  const breakpoint = 700;

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    navigate('/roleRequest?tab=' + newValue);
    setValue(newValue)
  };

  const location = useLocation();

  useEffect(() => {
    const tabParam = new URLSearchParams(location.search).get('tab') || ''
    if (isEmpty(tabParam)) {
      navigate('/roleRequest?tab=' + 'requestRoles');
    }
    setValue(tabParam)
  }, [location]);

  useEffect(()=>{

    const handleWindowSizeChange = () => {
      setwidth(window.innerWidth);
    };

    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  },[])


  if ( widthscreen > breakpoint){
    return (
      <>
      <div className="bannerAuth"  >
        <div className="leftbanner" >{" US and Non-US Persons "}</div >
        <div className="spanCenter">Technical Data<a  style={{textDecoration:'none', color:'#000'}} href="https://rtxusers.sharepoint.us/sites/enghub-PW/_layouts/15/settings.aspx">/</a>Information&nbsp;<strong>Strictly Prohibited</strong></div>
        <div className="rightbanner" >{" US and Non-US Persons "}</div >
    </div>
      <div className={styles.protectPage_title_container}>
      <div className={styles.protectPage_title}>Manage Access</div>
    </div>
    <main className={styles.protectedMain}> 
      <TabContext value={value}>
      {/* <Box component="div" sx={{ borderBottom: 1, borderColor: 'divider',width:'100%', paddingLeft:"112px" }} className = {styles.boxStyles}> */}
      <Box component="div" className = {styles.boxStyles}>
        <TabList onChange={handleChange} aria-label="roleRequest-Tabs" variant="scrollable" scrollButtons="auto">
          <Tab label="My Resources" value="myResources" className={styles.tabHeaderTextStyles} />
          <Tab label="New Request" value="requestRoles" className={styles.tabHeaderTextStyles}/>
          <Tab label="Resource Descriptions" value="resourceDescriptions"  className={styles.tabHeaderTextStyles}/>
          {/* <Tab label="MFA" value="mfa" /> */}
          <Tab label="My Engines" value="myEngineModels"  className={styles.tabHeaderTextStyles}/>
        </TabList>
      </Box>
      <TabPanel value="myResources"><MyRoleResources/></TabPanel>
      <TabPanel value="requestRoles"><RoleRequestPage/></TabPanel>
      <TabPanel value="resourceDescriptions"><RoleDescriptionPage/></TabPanel>
      {/* <TabPanel value="mfa"><ChangeMFA/></TabPanel> */}
      <TabPanel value="myEngineModels"><MyEngineModelStatus/></TabPanel>
    </TabContext>
    </main>
    </>
    )}
  else {
    return (
      <>
      <div className="bannerAuth"  >
        <div className="leftbanner" >{" US and Non-US Persons "}</div >
        <div className="spanCenter">Technical Data<a  style={{textDecoration:'none', color:'#000'}} href="https://rtxusers.sharepoint.us/sites/enghub-PW/_layouts/15/settings.aspx">/</a>Information&nbsp;<strong>Strictly Prohibited</strong></div>
        <div className="rightbanner" >{" US and Non-US Persons "}</div >
    </div>
      <div className={styles.protectPage_title_container}>
      <div className={styles.protectPage_title}>Manage Access</div>
    </div>
    <main className={styles.protectedMain}> 
      <TabContext value={value}>
      {/* <Box component="div" sx={{ borderBottom: 1, borderColor: 'divider',width:'100%', paddingLeft:"112px" }} className = {styles.boxStyles}> */}
      <Box component="div" className = {styles.boxStyles}>
        <TabList onChange={handleChange} aria-label="roleRequest-Tabs" variant="scrollable"  scrollButtons orientation="vertical" visibleScrollbar>
          <Tab label="My Resources" value="myResources" className={styles.tabHeaderTextStyles} />
          <Tab label="New Request" value="requestRoles" className={styles.tabHeaderTextStyles}/>
          <Tab label="Resource Descriptions" value="resourceDescriptions"  className={styles.tabHeaderTextStyles}/>
          {/* <Tab label="MFA" value="mfa" /> */}
          <Tab label="My Engines" value="myEngineModels"  className={styles.tabHeaderTextStyles}/>
        </TabList>
      </Box>
      <TabPanel value="myResources"><MyRoleResources/></TabPanel>
      <TabPanel value="requestRoles"><RoleRequestPage/></TabPanel>
      <TabPanel value="resourceDescriptions"><RoleDescriptionPage/></TabPanel>
      {/* <TabPanel value="mfa"><ChangeMFA/></TabPanel> */}
      <TabPanel value="myEngineModels"><MyEngineModelStatus/></TabPanel>
    </TabContext>
    </main>
    </>
    )
  }
};

export default RoleRequestTabs;
